import React from "react";
import DialogCover from "../DialogCover";
import LabResultListing from "../../lab-results/labResultsListing";
// import LabResultListing from "../../lab-results/labResultsListing";

function LabResultListingDialog({ shareDataDetail ,selectedChat}) {
  return (
    <DialogCover title="Lab Result" {...shareDataDetail}>
      <>
        <LabResultListing
          selectedChat={selectedChat}
          shareDataDetail={shareDataDetail}
          toggleSelectItem={(data) => {
            shareDataDetail?.setSelectedFiles(data);
          }}
        />
      </>
    </DialogCover>
  );
}

export default LabResultListingDialog;


